const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTMgMzQyIj4KPHJlY3QgeT0iMTE0IiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iNTEzIiBoZWlnaHQ9IjExNCIvPgo8cmVjdCB5PSIwIiBmaWxsPSIjRDgwMDI3IiB3aWR0aD0iNTEzIiBoZWlnaHQ9IjExNCIvPgo8cmVjdCB5PSIyMjgiIGZpbGw9IiNEODAwMjciIHdpZHRoPSI1MTMiIGhlaWdodD0iMTE0Ii8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=AT-8e538fc7.mjs.map
